import { Redirect, Route } from 'react-router-dom';
import { getRefreshTokenCookie, getSignupTokenCookie } from './Storage';

export default function CustomerRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>{
        return getRefreshTokenCookie() || getSignupTokenCookie? (
          <Component {...props} />
        ) : (
          <Redirect to="/auth/otp" />
        )
      }
        
      }
    />
  );
}
